<template>
    <div class="wineguide-container">
        <div class="itips-head">
            <div class="container">
                <div class="inner-page-title">{{ $t("home-top4") }}</div>
                <div class="inenr-page-breadcrumb">
                    <div class="inner-page-bread-line"></div>
                </div>
            </div>
        </div>
        <div class="container">
            <div class="wine-guide-body">
                <div class="wine-guide-left hide-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/avignonesi')">Avignonesi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country two-line"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri')">Azienda
                        Agricola Casanova di Neri
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/azienda-salvioni')">Azienda Salvioni
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/castiglione-del-bosco')">Castiglione del Bosco
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/conti-constani')">Conti Constani
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-le-pupille')">Fattoria Le Pupille
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fattoria-poggio-di-sotto')">Fattoria Poggio di
                        Sotto
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/fontodi')">Fontodi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/frescobaldi')">Frescobaldi
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/gianfranco-soldera')">Gianfranco Soldera
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/isole-e-olena')">Isole e Olena
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/marchesi-antinori')">Marchesi Antinori
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/podere-poggio-scalette')">Podere Poggio
                        Scalette
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/poderi-boscarelli')">Poderi Boscarelli
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/rocca-di-frassinello')">Rocca di Frassinello
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-dell-ornellaia')">Tenuta dell’Ornellaia
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-di-trinoro')">Tenuta di Trinoro
                    </nuxt-link>
                    <nuxt-link class="wine-guide-country active"
                               :to="localePath('/wine-guide/italy/tuscany/tenuta-san-guido')">Tenuta San Guido
                    </nuxt-link>
                </div>
                <div class="show-mobile">
                    <div class="wine-guide-left-title">
                        <nuxt-link class="wine-guide-back" :to="localePath('/wine-guide/italy/tuscany')"></nuxt-link>
                        Producers
                    </div>
                    <v-select
                        :items="items"
                        v-model="select"
                        label="Please choose"
                        single-line
                        item-text="report"
                        item-value="src"
                        return-object
                        class="show-mobile show-mobile-select"
                        v-on:change="changeRoute"
                    ></v-select>
                </div>
                <div v-if="$i18n.locale === 'it'" class="wine-guide-right">
                    <div class="howto-title">Tenuta San Guido</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Una sola parola potrebbe descrivere Tenuta San Guido: leggendaria. Il figlio dei sogni del Marchese Mario
                        Nicolò della Rocchetta (cugino degli Antinori della Tenuta dell'Ornellaia) Tenuta San Guido
                        è l'originale vino super toscano. Volendo creare un vino pregiato italiano che potesse rivaleggiare con il
                        onnipresente Bordeaux, Tenuta San Guido ha cambiato per sempre il volto del buon vino italiano.
                    </div>

                    <div class="howto-title2">Se ami il buon vino, amerai Tenuta San Guidov</div>
                    <div class="howto-text">
                        Di fronte a un terreno sassoso e, a prima vista, inospitale, della Rochetta notò delle somiglianze
                        tra il suo terroir e il terreno ghiaioso di Graves a Bordeaux. La sua idea era per lui
                        impianto xx ettari a Cabernet Sauvignon, ma era il 1940, la guerra aveva colpito duramente l'Italia e
                        sia la manodopera che il denaro erano scarsi. Le sue prime annate erano pesanti e antipatiche, per niente
                        successo che aveva sperato. Seguono quasi trent'anni di sperimentazione e il primo spot pubblicitario
                        L'uscita del Sassicaia (letteralmente pietrosa in dialetto locale) nel 1968 fu immediata
                        colpo. Il resto, come si suol dire, è storia.
                    </div>

                    <div class="howto-title2">L'inizio della fine delle antiquate leggi italiane sul vino pregiato</div>
                    <div class="howto-text">
                        Sotto Nicolo, San Guido è diventata la prima azienda italiana in assoluto ad avere una propria tenuta DOC nel 1994.
                        E, per buona misura, ha trasformato radicalmente la Bolgheri precedentemente insignificante
                        regione in quello che molti credono sia il fiore all'occhiello della corona vinicola italiana. Mentre il Marchese avanza
                        negli anni Sebastiano Rosa ha iniziato ad assumersi sempre più responsabilità. Si dice
                        che viene preparato per il miglior lavoro, anche se è “fiducioso che non lo sarà in qualsiasi momento
                        Presto".
                    </div>

                    <div class="howto-title2">Vino dell'anno 2018 di Wine Spectator</div>
                    <div class="howto-text">
                        Il Sassicaia di Tenuta San Guido è il vino italiano numero uno più ricercato. Nominato Wine Spectators Wine of Year nel 2018, l'annata 2016 è stata lanciata nel primo trimestre del 2019 a € 1.470 a cassa, tra
                        una raffica di punteggi alti; un perfetto 100 da Monica Larner di The Wine Advocate, qualsiasi cosa con
                        Il sigillo di approvazione di Robert Parker crescerà senza dubbio e crescerà. I prezzi del secondo trimestre sono già visibili
                        incrementi significativi, con bottiglie vendute fino a 354 euro, pari al 200% in tre mesi.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'de'" class="wine-guide-right">
                    <div class="howto-title">Tenuta San Guido</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Nur ein Wort könnte Tenuta San Guido beschreiben: legendär. Das Traumkind von Marchese Mario
                        Nicolò della Rocchetta (Cousin der Antinoris von Tenuta dell'Ornellaia) Tenuta San Guido
                        ist der originale Superwein der Toskana. Ich möchte einen guten italienischen Wein kreieren, der es mit dem aufnehmen kann
                        Tenuta San Guido, das allgegenwärtige Bordeaux, hat das Gesicht des italienischen Spitzenweins für immer verändert.
                    </div>

                    <div class="howto-title2">Wenn Sie guten Wein lieben, werden Sie Tenuta San Guidov lieben</div>
                    <div class="howto-text">
                        Angesichts eines steinigen und auf den ersten Blick unwirtlichen Bodens stellte della Rochetta Ähnlichkeiten fest
                        zwischen seinem Terroir und dem kiesigen Gelände von Graves in Bordeaux. Sein Geistesblitz war für ihn
                        xx Hektar mit Cabernet Sauvignon anbauen, aber das war 1940, der Krieg hatte Italien hart getroffen und
                        Sowohl Arbeitskräfte als auch Geld waren knapp. Seine frühen Jahrgänge waren schwer und unbeliebt, ganz und gar nicht
                        Erfolg, auf den er gehofft hatte. Es folgten fast dreißig Jahre des Experimentierens und der erste Werbespot
                        Die Freilassung von Sassicaia (was im lokalen Dialekt wörtlich „steiniger Boden“ bedeutet) im Jahr 1968 erfolgte unmittelbar
                        Schlag. Der Rest ist, wie man sagt, Geschichte.
                    </div>

                    <div class="howto-title2">Der Anfang vom Ende der antiquierten italienischen Weingesetze</div>
                    <div class="howto-text">
                        Unter Nicolo erhielt San Guido 1994 als erstes italienisches Weingut ein eigenes DOC.
                        Und ganz nebenbei hat es das zuvor unauffällige Bolgheri dramatisch verändert
                        Viele glauben, dass diese Region das Juwel in Italiens Weinkrone ist. Während der Marchese voranschreitet
                        Im Laufe der Jahre hat Sebastiano Rosa begonnen, immer mehr Verantwortung zu übernehmen. Gerüchten zufolge
                        dass er auf den Spitzenposten vorbereitet wird, obwohl er „zuversichtlich ist, dass das nicht irgendwann der Fall sein wird.“
                        bald".
                    </div>

                    <div class="howto-title2">Wine Spectator’s Wein des Jahres 2018</div>
                    <div class="howto-text">
                        Der Sassicaia von Tenuta San Guido ist der meistgesuchte italienische Wein. Der Jahrgang 2016 wurde 2018 von Wine Spectators zum Wein des Jahres gekürt und im ersten Quartal 2019 für 1.470 Euro pro Karton auf den Markt gebracht
                        eine Flut von Highscores; eine perfekte 100 von Monica Larner von The Wine Advocate, alles mit
                        Das Gütesiegel von Robert Parker wird zweifellos immer weiter wachsen. Die Preise für das 2. Quartal werden bereits angezeigt
                        deutliche Steigerungen, mit Flaschen zum Verkauf für bis zu 354 € oder 200 % in drei Monaten.
                    </div>
                </div>
                <div v-else-if="$i18n.locale === 'fr'" class="wine-guide-right">
                    <div class="howto-title">Tenuta San Guido</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Un seul mot pourrait décrire la Tenuta San Guido : légendaire. L'enfant de rêve de Marchese Mario
                        Nicolò della Rocchetta (cousin des Antinoris de la renommée Tenuta dell 'Ornellaia) Tenuta San Guido
                        est le super vin toscan original. Voulant créer un grand vin italien qui puisse rivaliser avec
                        omniprésente à Bordeaux, la Tenuta San Guido a changé à jamais le visage des grands vins italiens.
                    </div>

                    <div class="howto-title2">Si vous aimez le bon vin, alors vous allez adorer Tenuta San Guidov</div>
                    <div class="howto-text">
                        Face à un sol caillouteux et à première vue inhospitalier, della Rochetta a noté des similitudes
                        entre son terroir et le terrain graveleux des Graves à Bordeaux. Son cerveau était à son
                        planter xx hectares en Cabernet Sauvignon, mais nous étions en 1940, la guerre avait durement touché l'Italie et
                        la main-d'œuvre et l'argent étaient rares. Ses premiers millésimes étaient lourds et peu appréciés, pas du tout les
                        succès qu'il espérait. S'en sont suivi près de trente ans d'expérimentation et la première commercialisation
                        La sortie de Sassicaia (signifiant littéralement sol pierreux en dialecte local) en 1968 a été un effet immédiat
                        frapper. Le reste, comme on dit, appartient à l'histoire.
                    </div>

                    <div class="howto-title2">Le début de la fin des lois italiennes désuètes sur les vins fins</div>
                    <div class="howto-text">
                        Sous Nicolo, San Guido est devenu le premier domaine italien à avoir son propre domaine DOC en 1994.
                        Et, juste pour faire bonne mesure, il a radicalement transformé le Bolgheri auparavant banal.
                        région dans ce que beaucoup considèrent comme le joyau de la couronne des vins fins d'Italie. Au fur et à mesure que le marquis avance
                        Au fil des ans, Sebastiano Rosa a commencé à assumer de plus en plus de responsabilités. La rumeur veut
                        qu'il est préparé pour le poste le plus élevé, bien qu'il soit "confiant que ce ne sera pas n'importe quand
                        bientôt".
                    </div>

                    <div class="howto-title2">Vin de l'année 2018 du Wine Spectator</div>
                    <div class="howto-text">
                        Le Sassicaia de Tenuta San Guido est le vin italien le plus recherché. Nommé Wine Spectators Wine of Year en 2018, le millésime 2016 est sorti au premier trimestre 2019 à 1 470 € la caisse, au milieu
                        une rafale de scores élevés; un 100 parfait de Monica Larner de The Wine Advocate, tout avec
                        Le sceau d'approbation de Robert Parker va sans aucun doute grandir et grandir. Les prix du deuxième trimestre s'affichent déjà
                        des augmentations importantes, avec des bouteilles vendues jusqu'à 354 €, soit 200 % en trois mois.
                    </div>
                </div>
                <div v-else class="wine-guide-right">
                    <div class="howto-title">Tenuta San Guido</div>
                    <div class="howto-separator"></div>
                    <div class="howto-text">
                        Only one word could describe Tenuta San Guido: legendary. The dreamchild of Marchese Mario
                        Nicolò della Rocchetta (cousin of the Antinoris of Tenuta dell' Ornellaia fame) Tenuta San Guido
                        is the original super Tuscan wine. Wanting to create an Italian fine wine that could rival the
                        ubiquitous Bordeaux, Tenuta San Guido changed the face of Italian fine wine forever.
                    </div>

                    <div class="howto-title2">If you love fine wine, then you will love Tenuta San Guidov</div>
                    <div class="howto-text">
                        Faced with a stony, and at first glance, inhospitable soil, della Rochetta noted similarities
                        between his terroir and the gravelly terrain of Graves in Bordeaux. His brainwave was to his
                        plant xx hectares with Cabernet Sauvignon, but this was 1940, the war had hit Italy hard and
                        both manpower and money were scarce. His early vintages were heavy and unliked, not at all the
                        success he had hoped. Almost thirty years of experimentation followed and the first commercial
                        release of Sassicaia (literally meaning stony ground in local dialect) in 1968 was an immediate
                        hit. The rest, as they say, is history.
                    </div>

                    <div class="howto-title2">The beginning of the end of Italy’s antiquated fine wine laws</div>
                    <div class="howto-text">
                        Under Nicolo, San Guido became the first ever Italian estate to have its own estate DOC in 1994.
                        And, just for good measure, it dramatically transformed the previously unremarkable Bolgheri
                        region into what many believe is the jewel in Italy’s fine wine crown. As the Marchese advances
                        in years, Sebastiano Rosa has begun to take on more and more responsibilities. Rumour has it
                        that he is being groomed for the top job, although he is “confident that it won’t be anytime
                        soon”.
                    </div>

                    <div class="howto-title2">Wine Spectator’s Wine of Year 2018</div>
                    <div class="howto-text">
                        Tenuta San Guido’s Sassicaia is the number one most wanted Italian wine. Named as Wine Spectators Wine of Year in 2018, the 2016 vintage was released in Q1 2019 at €1,470 a case, amid
                        a flurry of high scores; a perfect 100 from Monica Larner of The Wine Advocate, anything with
                        Robert Parker’s seal of approval will undoubtedly grow and grow. Q2 prices already show
                        significant increases, with bottles for sale for as much as €354, or 200% in three months.
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "TenutaSanGuido",
    head: {
        title: 'Tenuta San Guido | Vindome Wine Guide',
        meta: [
            {
                hid: 'description',
                name: 'description',
                content: 'Discover the exceptional wine of Tenuta San Guido, a renowned wine producer in Tuscany. Indulge in the finest blends of Sangiovese and Cabernet Sauvignon made with passion and expertise. Explore the rich history and top-quality production of this iconic winery.'
            }
        ],
        bodyAttrs: {
            class: 'wine-guide inner-page'
        }
    },
    data() {
        return {
            select: {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'},
            items: [
                {report: 'Avignonesi', src: '/wine-guide/italy/tuscany/аvignonesi'},
                {
                    report: 'Azienda Agricola Casanova di Neri',
                    src: '/wine-guide/italy/tuscany/azienda-agricola-casanova-di-neri'
                },
                {report: 'Azienda Salvioni', src: '/wine-guide/italy/tuscany/azienda-salvioni'},
                {report: 'Castiglione del Bosco', src: '/wine-guide/italy/tuscany/castiglione-del-bosco'},
                {report: 'Conti Constani', src: '/wine-guide/italy/tuscany/conti-constani'},
                {report: 'Fattoria Le Pupille', src: '/wine-guide/italy/tuscany/fattoria-le-pupille'},
                {report: 'Fattoria Poggio di Sotto', src: '/wine-guide/italy/tuscany/fattoria-poggio-di-sotto'},
                {report: 'Fontodi', src: '/wine-guide/italy/tuscany/fontodi'},
                {report: 'Frescobaldi', src: '/wine-guide/italy/tuscany/frescobaldi'},
                {report: 'Gianfranco Soldera', src: '/wine-guide/italy/tuscany/gianfranco-soldera'},
                {report: 'Isole e Olena', src: '/wine-guide/italy/tuscany/isole-e-olena'},
                {report: 'Marchesi Antinori', src: '/wine-guide/italy/tuscany/marchesi-antinori'},
                {report: 'Podere Poggio Scalette', src: '/wine-guide/italy/tuscany/podere-poggio-scalette'},
                {report: 'Poderi Boscarelli', src: '/wine-guide/italy/tuscany/poderi-boscarelli'},
                {report: 'Tenuta dell’Ornellaia', src: '/wine-guide/italy/tuscany/tenuta-dell-ornellaia'},
                {report: 'Tenuta di Trinoro', src: '/wine-guide/italy/tuscany/tenuta-di-trinoro'},
                {report: 'Tenuta San Guido', src: '/wine-guide/italy/tuscany/tenuta-san-guido'}
            ]
        }
    },
    methods: {
        changeRoute(a) {
                this.$router.push({path: this.localePath(a.src) });
            }
    }
}
</script>

<style scoped>
.container {
    max-width: 1170px;
    padding: 0;
    font-family: 'Poppins', sans-serif;
}
.wine-guide-body {
    padding-top: 35px;
}

.wine-guide-left {
    width: 300px;
    display: inline-block;
}

.wine-guide-right {
    display: inline-block;
    width: calc(100% - 305px);
    vertical-align: top;
}

.wine-guide-left-title {
    font-weight: 600;
    color: #024E7B;
    font-size: 18px;
    height: 57px;
    line-height: 57px;
}

.wine-guide-country {
    display: block;
    height: 57px;
    line-height: 57px;
    text-decoration: none;
    color: #000;
    font-size: 16px;
    padding-left: 30px;
    width: 260px;
    border-left: 3px solid transparent;
}

.wine-guide-country:hover,
.wine-guide-country.active {
    border-color: #024E7B;
    background: #E5EDF2;
}
</style>
